import { trackComponent } from "@repo/analytics";
import { dlEventConstants } from "@repo/analytics/data-layer.constants";
import { getPageType } from "@repo/shared-utils/common-utils";
import { getCustomerIdForAnalytics } from "../../utils/analytics-utils";

/** Discover stocks carousel card click — Excel spec, owned in component code. */
export const DISCOVER_STOCKS_CT = {
  componentName: "similar_stocks_sku_carousel",
  componentId: "discover_stocks",
  clickType: "carousel click",
  productName: "trading_mall",
  productCategory: "stocks",
  propertyType: "clp",
} as const;

export interface ServiceSectionCtConfig {
  componentName: string;
  componentId: string;
  clickType: string;
  productName: string;
  productCategory: string;
  propertyType: string;
}

interface TrackDiscoverStocksCarouselClickInput {
  sectionTitle: string;
  ctaText: string;
  destinationUrl: string;
  analyticsConfig?: ServiceSectionCtConfig;
}

export async function trackDiscoverStocksCarouselClick({
  sectionTitle,
  ctaText,
  destinationUrl,
  analyticsConfig = DISCOVER_STOCKS_CT,
}: TrackDiscoverStocksCarouselClickInput): Promise<void> {
  try {
    const customerId = await getCustomerIdForAnalytics();
    const eventName = getPageType("tag-8");

    await trackComponent({
      eventName,
      componentName: analyticsConfig.componentName,
      componentId: analyticsConfig.componentId,
      clickType: analyticsConfig.clickType,
      eventType: dlEventConstants.CLICK,
      sectionTitle,
      ctaText,
      destinationUrl,
      productName: analyticsConfig.productName,
      productCategory: analyticsConfig.productCategory,
      pageType: analyticsConfig.propertyType,
      cleverTapOverrides: {
        EP_PROPERTY_TYPE: analyticsConfig.propertyType,
        EP_PRODUCT_NAME: analyticsConfig.productName,
        EP_PRODUCT_CATEGORY: analyticsConfig.productCategory,
        EP_REFERENCE_ID: analyticsConfig.componentId,
        ...(customerId && { EP_CUSTOMER_ID: customerId }),
      },
    });
  } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to track discover stocks carousel click", error);
  }
}
